import { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import { selectIsPLG, selectUserUuid } from '@redux/slices/userSlice';
import { useGetAccountData, getAccountData } from '@queries/platform/accountSettings';
import AccountSettings from './accountSettings';

const AccountSettingsContainer: FC<AccountSettingsContainerProps> = ({
    setIsAccountSettingsOpen
}: AccountSettingsContainerProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const userUuid = useSelector(selectUserUuid);
    const { isLoading: isLoadingAccountData, isError, data, refetch } = useGetAccountData(userUuid);
    const accountData = data?.account_data;
    const isPLG = useSelector(selectIsPLG);

    const onCloseAccountSettings = () => {
        queryClient.removeQueries([getAccountData, userUuid]);
        setIsAccountSettingsOpen(false);
    };

    useEffect(() => {
        isLoadingAccountData ? setIsLoading(true) : setIsLoading(false);
    }, [isLoadingAccountData]);

    return (
        <AccountSettings
            isEmailNotificationsEnabled={accountData?.email_notifications_enabled}
            isPrimaryCourseEnabled={accountData?.primary_course_update_enabled}
            isSso={accountData?.is_sso}
            isPLG={isPLG}
            loginIntegration={accountData?.login_integration}
            isLoading={isLoading || (!accountData && !isError)}
            isError={isError}
            onRetry={() => refetch()}
            setIsLoading={setIsLoading}
            onClose={() => onCloseAccountSettings()}
        />
    );
};

interface AccountSettingsContainerProps {
    setIsAccountSettingsOpen: Function;
}

export default AccountSettingsContainer;
